import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { GlobalModule } from '@fuse/global.module';
import { MaterialModule } from '@fuse/material.module';
import { AllFieldsViewComponent } from './all-fields-view.component';
import { CalenderTemplateModule } from '../../apps/calendar-template/calendar.module';
import { ProcessGraphViewModule } from '../../components/process-graph-view/process-graph-view.module';
import { RecordCommentModule } from '../control-template/record-comment/record-comment.module';
import { ProcessStatusModule } from '../control-template/process-status/process-status.module';
import { OfficeListPopupModule } from '../../apps/office-list-popup/office-list-popup.module';

@NgModule({
    imports     : [
       FuseSharedModule,
        GlobalModule,
        MaterialModule,
        ProcessGraphViewModule,
        RecordCommentModule,
        ProcessStatusModule,
        OfficeListPopupModule
         
    ],
    // exports: [
    //   EditNg5Component,
    // ],
    declarations: [
        AllFieldsViewComponent,
        // FormViewComponent
    ],
    exports: [
        AllFieldsViewComponent
    ]
})
export class AllFieldsViewModule
{
}
